// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-logo',
    props: {
        logoMode: {
            type: String,
            required: false,
            default: 'default'
        },
    },
});
// #endregion
